import React from "react";
import { useGlobalMerchant } from 'utils/helper';
import ECThemeComponent from 'components/Ecommerce/ECTheme/ECThemeComponent';
import { BasketProvider } from "containers/POSContainer/constant";

const ECThemeContainer = () => {
  const { paymentIframeURL } = useGlobalMerchant();
  return (
    <BasketProvider>
      <ECThemeComponent />
    </BasketProvider>
  );
};

export default ECThemeContainer;
